import dayjs from 'dayjs';
import { useMemo } from 'react';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';

const parseJwt = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
};

const isTokenExpired = (token: string) => {
  const payload = parseJwt(token);
  if (!payload) return true;
  const now = dayjs();
  if (payload.lifetime && payload.iat) {
    const issuedAt = dayjs.unix(payload.iat);
    const expirationTime = issuedAt.add(payload.lifetime, 'seconds');
    return now.isAfter(expirationTime);
  }
  return true;
};

/**
 * Custom hook to check if the JWT access token stored in localStorage is valid and not expired.
 * @returns `true` if a valid, non-expired token exists; otherwise `false`.
 */
export const useJwt = () => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

  return useMemo(() => {
    return !!token && !isTokenExpired(token);
  }, [token]);
};
